import SahamDialog from 'components/SahamDialog';
import { translate } from 'containers/services/translate';
import React, { MouseEventHandler, useState } from 'react';
import messages from 'containers/CourtManagerLegalProceedings/Provision/Regulation/messages';
import { injectIntl, IntlShape } from 'react-intl';
import { TextField } from '@material-ui/core';
import { get, isEmpty } from 'lodash';
import { PROVISION } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/data-structure';
import {
  getRiskCorpoProvision,
  numberWithCommas,
} from 'containers/CourtManagerLegalProceedings/Provision/Regulation/utils';
import SahamAccordion from 'components/SahamAccordion';
import { getValueByCode } from 'containers/CourtManagerLegalProceedings/Provision/utils';
import { Listings } from 'containers/AppContainer/typings';
import { LISTINGS } from 'containers/data-structure';
import { ProvisionContainer } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/styled-components';
import { RcCorporeal } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/typings';
import { PROVISION_ITEM } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/constants';

export interface ProvisionDialogProps {
  intl: IntlShape;
  handleValidate: any;
  handleClose: any;
  title: any;
  open: boolean;
  setProvisionInfo: Function;
  provisionInfo: any;
  sagisClaim: any;
  listings: Listings;
  rcCorpo: RcCorporeal;
}
const ProvisionDialog: React.FC<ProvisionDialogProps> = (
  props,
): JSX.Element => {
  const [expanded, setExpanded] = useState({
    victimProvision: false,
    intervenantProvision: false,
  });
  const handleChangeExpanded = (event: React.ChangeEvent<{}>, item: string) => {
    setExpanded({ ...expanded, [item]: !get(expanded, item, false) });
  };

  const handleChangeProvision = (item: string, intervenant?: any) => (
    event: React.ChangeEvent<{ name?: any; value: any }>,
  ) => {
    const provisionInfo = { ...props.provisionInfo };
    switch (event.target.name) {
      case PROVISION.VICTIM_AMOUNT:
        provisionInfo[item][event.target.name] = numberWithCommas(
          event.target.value,
        );
        break;
      case PROVISION.CONTRIBUTOR_AMOUNT:
        provisionInfo[item][
          `${intervenant.contractorCode}-${intervenant.contractorTypeCode}`
        ] = {};

        provisionInfo[item][
          `${intervenant.contractorCode}-${intervenant.contractorTypeCode}`
        ][event.target.name] = numberWithCommas(event.target.value);

        provisionInfo[item][
          `${intervenant.contractorCode}-${intervenant.contractorTypeCode}`
        ][PROVISION.CONTRIBUTOR_TYPE_CODE] = intervenant.contractorTypeCode;
        provisionInfo[item][
          `${intervenant.contractorCode}-${intervenant.contractorTypeCode}`
        ][PROVISION.CONTRIBUTOR_CODE] = intervenant.contractorCode;
        provisionInfo[item][
          `${intervenant.contractorCode}-${intervenant.contractorTypeCode}`
        ][PROVISION.RISK_ID] = get(intervenant, 'riskKey', '');
        break;
      default:
        provisionInfo[item][event.target.name] = event.target.value;
    }
    props.setProvisionInfo(provisionInfo);
  };
  return (
    <SahamDialog
      handleValidate={props.handleValidate}
      handleClose={props.handleClose as MouseEventHandler}
      title={props.title}
      cancelTitle={translate(messages.cancelButton, props)}
      confirmTitle={translate(messages.confirmationButton, props)}
      open={props.open}
      validateButtonDisabled={
        isEmpty(
          get(props.provisionInfo[PROVISION_ITEM.VICTIMS], 'provisionReason'),
        ) &&
        !isEmpty(
          get(props.provisionInfo[PROVISION_ITEM.VICTIMS], 'provisionAmount'),
        )
      }
    >
      <ProvisionContainer>
        <SahamAccordion
          key={`provision-victims-${get(props.rcCorpo, 'regulationId')}`}
          title={translate(messages.provisionVictimDialog, props)}
          expanded={get(expanded, 'victimProvision', false)}
          onChange={_ => handleChangeExpanded(_, 'victimProvision')}
        >
          <div>
            <a>{translate(messages.updateProvisionContent, props)}</a>
            <TextField
              name={PROVISION.VICTIM_AMOUNT}
              data-testid={PROVISION.VICTIM_AMOUNT}
              label={translate(messages.provisionAmount, props)}
              onChange={handleChangeProvision(PROVISION_ITEM.VICTIMS)}
              value={
                get(props.provisionInfo[PROVISION_ITEM.VICTIMS], [
                  PROVISION.VICTIM_AMOUNT,
                ]) ||
                numberWithCommas(
                  get(
                    getRiskCorpoProvision(
                      props.sagisClaim,
                      get(props.rcCorpo, 'riskID'),
                    ),
                    'riskProvisionVictims',
                    '',
                  ),
                )
              }
              fullWidth
              style={{ marginTop: 5 }}
            />
            <TextField
              name={PROVISION.REASON}
              data-testid={PROVISION.REASON}
              label={translate(messages.provisionComment, props)}
              onChange={handleChangeProvision(PROVISION_ITEM.VICTIMS)}
              value={get(
                props.provisionInfo[PROVISION_ITEM.VICTIMS],
                'provisionReason',
                '',
              )}
              fullWidth
              style={{ marginTop: 8 }}
            />
          </div>
        </SahamAccordion>
        <SahamAccordion
          key={`provision-intevenant-${get(props.rcCorpo, 'regulationId')}`}
          title={translate(messages.provisionIntervenantDialog, props)}
          expanded={get(expanded, 'provisionIntervenant', false)}
          onChange={_ => handleChangeExpanded(_, 'provisionIntervenant')}
        >
          <div className="provision-content">
            {get(props.sagisClaim, 'contractorFees', [])
              .filter(
                (item: any) => item?.riskKey === get(props.rcCorpo, 'riskID'),
              )
              .map((intervenant: any) => (
                <div className="item-row">
                  <span className="intervenant-item">
                    {getValueByCode(
                      intervenant.contractorCode,
                      get(props.listings, LISTINGS.INTERVENANT_NAME, []),
                    )}
                  </span>

                  <TextField
                    name={PROVISION.CONTRIBUTOR_AMOUNT}
                    data-testid={PROVISION.CONTRIBUTOR_AMOUNT}
                    label={translate(messages.provisionAmount, props)}
                    onChange={handleChangeProvision(
                      PROVISION_ITEM.CONTRIBUTORS,
                      intervenant,
                    )}
                    value={
                      get(
                        props.provisionInfo[PROVISION_ITEM.CONTRIBUTORS][
                          `${intervenant.contractorCode}-${intervenant.contractorTypeCode}`
                        ],
                        [PROVISION.CONTRIBUTOR_AMOUNT],
                      ) || get(intervenant, 'amount')
                    }
                    style={{ marginTop: 5, width: '30%' }}
                  />
                </div>
              ))}
          </div>
        </SahamAccordion>
      </ProvisionContainer>
    </SahamDialog>
  );
};
export default injectIntl(ProvisionDialog);
